import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import LeaveApplicationsTab from "@/pages/hr/leave/LeaveApplicationsTab";
import LeaveBalancesTab from "@/pages/hr/leave/LeaveBalancesTab";
import LeaveLedgerTab from "@/pages/hr/leave/LeaveLedgerTab";
import LeaveTypesTab from "@/pages/hr/leave/LeaveTypesTab";
import LeaveHistoricalTab from "@/pages/hr/leave/LeaveHistoricalTab";
import LeaveAutoCountTab from "@/pages/hr/leave/LeaveAutoCountTab";
import LeaveCutoverTab from "@/pages/hr/leave/LeaveCutoverTab";

export default function LeaveTab() {
  const { can } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [types, setTypes] = useState([]);

  const reloadTypes = () => api.get("/hr/leave/types").then((r) => setTypes(r.data)).catch(() => {});
  useEffect(() => {
    api.get("/hr/employees").then((r) => setEmployees(r.data)).catch(() => {});
    reloadTypes();
  }, []);

  const shared = { employees, types, reloadTypes };
  const subtabs = [
    { id: "applications", label: "Applications", show: can("leave:view_team") || can("leave:view_all"), el: <LeaveApplicationsTab {...shared} /> },
    { id: "balances", label: "Leave Balances", show: can("leave:view_team") || can("leave:view_all") || can("leave:balance_manage"), el: <LeaveBalancesTab {...shared} /> },
    { id: "ledger", label: "Leave Ledger", show: can("leave:balance_manage") || can("leave:view_all"), el: <LeaveLedgerTab {...shared} /> },
    { id: "types", label: "Leave Types", show: can("leave:type_manage"), el: <LeaveTypesTab {...shared} /> },
    { id: "historical", label: "Historical (AutoCount)", show: can("leave:view_team") || can("leave:view_all") || can("leave:import_autocount"), el: <LeaveHistoricalTab {...shared} /> },
    { id: "autocount", label: "AutoCount Import", show: can("leave:import_autocount"), el: <LeaveAutoCountTab {...shared} reloadTypes={reloadTypes} /> },
    { id: "cutover", label: "Go-Live Cutover", show: can("leave:import_autocount"), el: <LeaveCutoverTab /> },
  ].filter((t) => t.show);
  const [tab, setTab] = useState(subtabs[0]?.id);

  return (
    <div data-testid="hr-leave-tab">
      <div className="flex gap-1 mb-4 flex-wrap">
        {subtabs.map((t) => (
          <button key={t.id} data-testid={`leave-subtab-${t.id}`} onClick={() => setTab(t.id)}
            className={`px-3 py-1.5 text-sm rounded-md font-medium ${tab === t.id ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{t.label}</button>
        ))}
      </div>
      {subtabs.find((t) => t.id === tab)?.el}
    </div>
  );
}
